import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const eventManagementRoutes = [
  {
    path: 'events',
    component: DummyRouter,
    meta: { permissionAction: PermissionActions.EventsView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/eventManagement/views/calendar/EventManagementCalendar.vue'),
        meta: { permissionAction: PermissionActions.EventsView },
      },
      {
        path: ':eventId',
        component: () => import('@/features/eventManagement/views/eventEdit/EventEditPage.vue'),
        children: [],
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.EventsUpdate,
        },
      },
      {
        path: 'new',
        component: () => import('@/features/eventManagement/views/eventEdit/EventEditPage.vue'),
        children: [],
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.EventsCreate,
        },
      },
    ],
  },
]
